export default `
	guid
    name
    email
    active
`;
